module.exports = __webpack_public_path__ + "img/picture10.f628c268.png";